
export default {
    namespaced: true,
    state: {
        genAIDialogVisible: false
    },
    mutations: {
        openGenAIDialog (state, payload) {
            state.genAIDialogVisible = {
                ...payload,
                visible: true
            }
        },
        closeGenAIDialog (state) {
            state.genAIDialogVisible = {
                visible: false
            }
        }
    },
    actions: {


    }
}
